document.addEventListener("DOMContentLoaded", () => {
	const blocks = document.querySelectorAll(".vb-lottie-frontend");

	if (typeof lottie === "undefined") {
		const script = document.createElement("script");
		script.src = "https://cdnjs.cloudflare.com/ajax/libs/bodymovin/5.10.2/lottie.min.js";
		script.onload = () => {
			blocks.forEach((el) => {
				const id = el.getAttribute('id');
				initLottie(el, id);
			});
		};
		document.body.appendChild(script);
	} else {
		blocks.forEach((el) => {
			const id = el.getAttribute('id');
			initLottie(el, id);
		});
	}
});

function initLottie(el, id) {
	const speed = parseFloat(el.dataset.speed);
	const direction = parseInt(el.dataset.direction) || 1;
	const start = parseInt(el.dataset.start);
	const end = parseInt(el.dataset.end);
	const loop = true;
	const autoplay = true;

	const trigger = el.dataset.trigger;
	const top = parseInt(el.dataset.top);
	const bottom = parseInt(el.dataset.bottom);

	const anim = lottie.loadAnimation({
		container: el,
		renderer: "svg",
		loop,
		autoplay: autoplay && trigger === "none",
		path: el.dataset.lottie,
	});

	anim.setSpeed(speed);
	anim.setDirection(direction);
	anim.playSegments([start, end], false);

	if (trigger === "viewport") {
		window.addEventListener("scroll", () => {
			const rect = el.getBoundingClientRect();
			const windowHeight = window.innerHeight;

			// Calculate visibility % based on top/bottom thresholds
			const topPercent = isNaN(top) ? 100 : top;
			const bottomPercent = isNaN(bottom) ? 0 : bottom;

			// Range in viewport height
			const visibleStart = windowHeight * (bottomPercent / 100);
			const visibleEnd = windowHeight * (topPercent / 100);

			// Check if the element is within that range
			const visible = rect.top < visibleEnd && rect.bottom > visibleStart;

			if (visible) {
				anim.playSegments([start, end], true);
			}
		});
	}else if (trigger === "scroll") {
		window.addEventListener("scroll", () => {
			const rect = el.getBoundingClientRect();
			const vh = window.innerHeight;

			const top = parseInt(el.dataset.top || "100");
			const bottom = parseInt(el.dataset.bottom || "0");

			const startFrame = parseInt(el.dataset.start || "0");
			const endFrame = parseInt(el.dataset.end || "100");
			const midFrame = Math.floor((endFrame - startFrame) / 2 + startFrame);

			const visibleStart = vh * (bottom / 100);
			const visibleEnd = vh * (top / 100);
			const elementMid = rect.top + rect.height / 2;

			if (rect.bottom < visibleStart || rect.top > visibleEnd) {
				// Not in range
				return;
			}

			const visibilityPercent = (elementMid - visibleStart) / (visibleEnd - visibleStart);
			const clamped = Math.max(0, Math.min(1, visibilityPercent));

			// 🎯 Phase-based frame logic
			if (clamped < 0.05) {
				anim.goToAndStop(startFrame, true);
			} else if (clamped >= 0.05 && clamped <= 0.95) {
				const seek = startFrame + (midFrame - startFrame) * ((clamped - 0.05) / 0.9);
				anim.goToAndStop(seek, true);
			} else {
				// Final phase
				if (loop) {
					anim.playSegments([midFrame, endFrame], true);
				} else {
					anim.playSegments([midFrame, endFrame], false);
				}
			}
		});
	}else if(trigger === 'click') {
		let isPlaying = false;

		el.addEventListener('click', () => {
			if (!isPlaying) {
				anim.play();
				isPlaying = true;
			} else {
				anim.pause();
				isPlaying = false;
			}
		});
	}else if(trigger === 'hover'){
		el.addEventListener('mouseenter', () => {
			anim.play();
		});

		el.addEventListener('mouseleave', () => {
			anim.pause();
		});
	}

	// Global + DOM level storage
	window[`lottie_${id}`] = anim;
	el.lottieInstance = anim;

}